<template>
  <div class="p-3">
    <DxDataGrid
      :data-source="sync"
      :show-borders="true"
      :show-column-lines="true"
      :show-row-lines="true"
      :row-alternation-enabled="true"
      :columnAutoWidth="true"
      :allow-column-resizing="true"
    >
      <DxPaging :page-size="30" />
      <DxHeaderFilter :visible="true" />
      <DxFilterRow :visible="true">
        <DxOperationDescriptions
          equal="Igual a"
          notEqual="Diferente de"
          startsWith="Empieza con"
          endsWith="Termina con"
          contains="Contiene"
          between="Entre"
          notContains="No contiene"
          lessThanOrEqual="Menor o igual"
          greaterThanOrEqual="Mayor o igual"
          lessThan="Menor que"
          greaterThan="Mayor que"
        />
      </DxFilterRow>
      <DxSearchPanel :visible="false" :width="240" placeholder="Buscar..." />
      <DxGroupPanel
        :visible="true"
        emptyPanelText="Arrastre una columna aquí para agrupar"
      />
      <DxPager
        :visible="true"
        infoText="Página {0} of {1} ({2} registros)"
        :allowed-page-sizes="pageSizes"
        display-mode="full"
        :show-page-size-selector="true"
        :show-info="true"
        :show-navigation-buttons="true"
      />
    </DxDataGrid>
  </div>
</template>
<style>
.dx-header-row > td[aria-label="Column Detalle"],
.dx-header-row > td[aria-label="Column Titulo"] {
  overflow-x: hidden !important;
}
</style>
<script>
import {
  DxDataGrid,
  DxPaging,
  DxFilterRow,
  DxHeaderFilter,
  DxOperationDescriptions,
  DxPager,
  DxSearchPanel,
  DxGroupPanel,
} from "devextreme-vue/data-grid";
export default {
  components: {
    DxSearchPanel,
    DxDataGrid,
    DxPaging,
    DxFilterRow,
    DxHeaderFilter,
    DxGroupPanel,
    DxOperationDescriptions,
    DxPager,
  },
  props: {
    sync: {
      type: Array,
      default: () => [],
    },
  },
  data(){
    return {
      pageSizes: [5, 10, 15, 30, 50],
    }
  }
};
</script>
